import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CvrUpload from "@/types/CvrUpload";
import ConfirmationModal from "@/components/CvrConvert/ConfirmationModal.vue";
import { ref } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AbortButton',
  props: {
    item: {},
    reload: { type: Function },
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const requesting = ref(false);
const confirmationModalState = ref(false);

async function abort() {
  requesting.value = true;
  const parentId = props.item.parent_id;
  if (parentId) {
    const res = await Api().abortCvrUpload(parentId).catch((error) => {
      console.error(error);
    });
    if (res) {
      props.showFlash(
        i18n.global.t('pages.cvr_uploads.abortMessages.success'), "success");
      props.reload();
    }
  } else {
    console.error("parent_id is null and cannot be used to abort cvr upload request.");
    props.showFlash(
      i18n.global.t('pages.cvr_uploads.abortMessages.error'), "error");
  }
  confirmationModalState.value = false;
  requesting.value = false;
}

function showConfirmation() {
  confirmationModalState.value = true;
}

function closeConfirmation() {
  confirmationModalState.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: showConfirmation,
      class: "bg-warning"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.list.abortBtn')), 1)
      ]),
      _: 1
    }),
    _createVNode(ConfirmationModal, {
      modalState: confirmationModalState.value,
      onConfirm: abort,
      onCancel: closeConfirmation,
      loading: requesting.value,
      title: _unref(i18n).global.t('pages.cvr_uploads.abortMessages.confirmationModalTitle'),
      note: _unref(i18n).global.t('pages.cvr_uploads.abortMessages.confirmationModalContent'),
      rightBtnName: _unref(i18n).global.t('pages.cvr_uploads.abortMessages.confirmationModalBtnLabel')
    }, null, 8, ["modalState", "loading", "title", "note", "rightBtnName"])
  ], 64))
}
}

})